import { Button, DatePicker, Divider, Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { useEffect } from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';

import BtnSave from './BtnSave';

import { INIT } from './init';
import { POLICY_NAME } from '../../POLICY';

export const checkValidForm = (fields, values) => {
    for (const [key, value] of Object.entries(values)) {
        if (fields.includes(key) && (!value || value?.length === 0)) {
            return false;
        }
    }
    return true;
};

const Step1 = (props) => {
    const { t } = useTranslation(['translation', POLICY_NAME.CCTV_POLICY]);

    const onNextStep = () => {
        props.nextStep();
        props?.form
            .validateFields()
            .then(() => {
                props.setStep1(true);
            })
            .catch(() => props.setStep1(false));
    };

    useEffect(() => {
        if (props?.previewData?.requiredInformation) {
            onValuesChange(null, props.previewData?.requiredInformation);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = [
            'dpaName',
            'contractDate',
            'ownerCompanyName',
            'ownerCompanyAddress',
            'ownerFullName',
            'ownerPosition',
            'counterpartyCompanyName',
            'counterpartyCompanyAddress',
            'counterpartyFullName',
            'counterpartyPosition',
            'mainContractName',
            'purpose',
            'personalData',
            'frequencyForSendRopa',
            'amtDestroyData',
            'trackUsage',
            'dpaPolicyDataSubjectType',
        ];
        const check = checkValidForm(fields, allValues);
        props.setStep1(check);
    };

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                ข้อมูลที่จำเป็นต้องระบุ
            </div>
            <div className="text-gray-500 text-tiny">
                เริ่มกรอกนโยบายของคุณได้เลย
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="requiredInformation"
                layout="vertical"
                form={props?.form}
                initialValues={INIT.requiredInformation}
            >
                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            ชื่อสัญญาประมวลผลข้อมูลส่วนบุคคล
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="dpaName"
                >
                    <Input
                        size="large"
                        placeholder="ชื่อสัญญาประมวลผลข้อมูลส่วนบุคคล"
                    />
                </Form.Item>

                <Form.Item
                    className="mt-4"
                    name="contractDate"
                    label={
                        <span className="text-[21px] font-bold">
                            วันที่ทำสัญญาฉบับนี้
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <DatePicker
                        allowClear={false}
                        size="large"
                        style={{ width: '100%' }}
                        placeholder="DD/MM/YYYY"
                        format="DD/MM/YYYY"
                    />
                </Form.Item>

                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            ชื่อองค์กร (หรือชื่อบุคคลเจ้าของ)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="ownerCompanyName"
                >
                    <Input
                        size="large"
                        placeholder="ชื่อองค์กร (หรือชื่อบุคคลเจ้าของ)"
                    />
                </Form.Item>

                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            ที่อยู่บริษัทของคุณ
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="ownerCompanyAddress"
                >
                    <Input size="large" placeholder="ที่อยู่บริษัทของคุณ" />
                </Form.Item>

                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            ชื่อ - นามสกุลจริง ของกรรมการหรือผู้มีอำนาจลงนาม
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="ownerFullName"
                >
                    <Input size="large" placeholder="ชื่อ - นามสกุล" />
                </Form.Item>

                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            ชื่อตำแหน่งของกรรมการหรือผู้มีอำนาจลงนาม
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="ownerPosition"
                >
                    <Input
                        size="large"
                        placeholder="ชื่อตำแหน่งของกรรมการหรือผู้มีอำนาจลงนาม"
                    />
                </Form.Item>

                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            ชื่อองค์กรคู่สัญญา (หรือชื่อบุคคลเจ้าของคู่สัญญา)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="counterpartyCompanyName"
                >
                    <Input
                        size="large"
                        placeholder="ชื่อองค์กรคู่สัญญา (หรือชื่อบุคคลเจ้าของคู่สัญญา)"
                    />
                </Form.Item>

                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            ที่อยู่บริษัทคู่สัญญา
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="counterpartyCompanyAddress"
                >
                    <Input size="large" placeholder="ที่อยู่บริษัทคู่สัญญา" />
                </Form.Item>

                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            ชื่อ - นามสกุลจริง
                            ของกรรมการหรือผู้มีอำนาจลงนามของบริษัทคู่สัญญา
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="counterpartyFullName"
                >
                    <Input size="large" placeholder="ชื่อ - นามสกุล" />
                </Form.Item>

                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            ชื่อตำแหน่งของกรรมการหรือผู้มีอำนาจลงนามของบริษัทคู่สัญญา
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="counterpartyPosition"
                >
                    <Input
                        size="large"
                        placeholder="ชื่อตำแหน่งของกรรมการหรือผู้มีอำนาจลงนามของบริษัทคู่สัญญา"
                    />
                </Form.Item>
                <div>
                    <span className="text-[21px] font-bold">
                        ชื่อสัญญาหรือโครงการที่บริษัทของคุณได้เข้าทำสัญญา
                        (รายชื่อสัญญาหลัก){' '}
                        <span className="required_sign">*</span>
                    </span>
                    <span className="pb-4 text-[#1890FF] block">
                        หากมีมากกว่า 1 สัญญา ให้คั่นด้วยเครื่องหมาย comma (,)
                        เช่น “สัญญา ก. 20 กุมภาพันธ์ 2550, สัญญา ข. 1 ธันวาคม
                        2560”
                    </span>
                </div>
                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="mainContractName"
                >
                    <Input
                        size="large"
                        placeholder="ชื่อสัญญาหรือโครงการที่บริษัทของคุณได้เข้าทำสัญญา"
                    />
                </Form.Item>

                <Form.Item
                    className="mt-4"
                    name="purpose"
                    label={
                        <span className="text-[21px] font-bold">
                            กำหนดวัตถุประสงค์ในการประมวลผลข้อมูลส่วนบุคคลที่มอบหมายให้คู่สัญญาดำเนินการ
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder="ระบุข้อความหรือระบุเป็นข้อๆ ได้"
                    />
                </Form.Item>

                <Form.Item
                    className="mt-4"
                    name="personalData"
                    label={
                        <span className="text-[21px] font-bold">
                            ข้อมูลส่วนบุคคลที่บริษัทมอบหมายให้คู่สัญญาประมวลผล
                            ประกอบด้วย
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder="ระบุข้อความหรือระบุเป็นข้อๆ ได้"
                    />
                </Form.Item>

                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            ระบุความถี่ของการส่งมอบบันทึกรายการของกิจกรรมการประมวลผลข้อมูลส่วนบุคคล
                            (Record of Processing)
                            ของคู่สัญญาที่จะส่งให้ผู้ควบคุมข้อมูล
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="frequencyForSendRopa"
                >
                    <Input
                        size="large"
                        placeholder="ตัวอย่าง : ทุกสัปดาห์หรือทุกเดือน"
                    />
                </Form.Item>
                <div>
                    <span className="text-[21px] font-bold">
                        ระบุจำนวนวันที่จะทำการลบหรือทำลายข้อมูล (วัน){' '}
                        <span className="required_sign">*</span>
                    </span>
                    <span className="pb-4 text-[#1890FF] block">
                        ผู้ควบคุมข้อมูลจะทำการลบหรือทำลายข้อมูลส่วนบุคคลที่ทำการประมวลผลภายใต้ข้อตกลงฉบับนี้ภายใน
                        (X) วัน นับแต่วันที่ดำเนินการประมวลผลเสร็จสิ้น
                    </span>
                </div>
                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="amtDestroyData"
                >
                    <Input
                        onKeyDown={(event) => {
                            if (
                                ![8, 46].includes(event.keyCode) &&
                                !/[0-9]/.test(event.key)
                            ) {
                                event.preventDefault();
                            }
                        }}
                        size="large"
                        placeholder="ระบุเป็นตัวเลข เช่น 180"
                    />
                </Form.Item>

                <Form.Item
                    className="mt-4"
                    name="trackUsage"
                    label={
                        <span className="text-[21px] font-bold">
                            หลังส่งมอบข้อมูลแก่คู่สัญญาแล้ว
                            มีการติดตามการใช้งานข้อมูลเป็นครั้งคราวทุกกี่เดือน
                            หรือกี่ปี
                            เพื่อบันทึกสถานะล่าสุดในการใช้งานข้อมูลนั้น
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        placeholder="ตัวอย่าง : ทุก 3 เดือน 6 เดือน หรือ 1 ปี"
                    />
                </Form.Item>

                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            นโยบายนี้ใช้กับเจ้าของข้อมูลประเภทใด
                        </span>
                    }
                    className="mt-4"
                    name="dpaPolicyDataSubjectType"
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Select
                        placeholder="เลือกประเภทเจ้าของข้อมูล"
                        style={{ width: '100%' }}
                        size="large"
                        allowClear
                        mode="multiple"
                    >
                        {props.dsType?.map((dsType) => (
                            <Select.Option key={dsType?.id} value={dsType?.id}>
                                {dsType?.nameTh}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item hidden name="dpaPolicyId"></Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="primary"
                            size="large"
                            onClick={onNextStep}
                        >
                            {t('policy.NextStep')} <ArrowRightOutlined />
                        </Button>
                        <BtnSave
                            loading={props.loadingSaveDraft}
                            saveDraft={props.saveDraft}
                        />
                    </div>
                </Sticky>
            </Form>
        </div>
    );
};
export default Step1;
